export default __webpack_public_path__ + "static/media/astra.3e97a48f.svg";